// ItemThumb — ONE product thumbnail for BOTH order surfaces: the account card
// list (OrderCardList preview rows) and the order detail (OrderDetailView line
// rows). Extracted from a ~40-line copy-paste that was already mechanically
// diverging (TILE_PX=64 constant vs a hardcoded 64): identical 64px geometry,
// cardBorder, and the S5/A labelled placeholder — role="img" with
// aria-label `${name} (no image)`, so an image-less line keeps the product
// name in the accessibility tree and is never an unlabelled grey square.
//
// Takes primitives (name/imageUrl), not a wire item: the two surfaces read
// different shapes (OrderPreviewItem vs the detail line), the pixels are the
// same. Marketplace-local rather than embed-shared — this is order-domain
// presentation with exactly two consumers, not a cross-embed primitive.

import { useEmbedTokens } from "../../embed-shared/primitives";

const TILE_PX = 64;

export function ItemThumb({ name, imageUrl }: { name: string; imageUrl: string | null }) {
  const t = useEmbedTokens();
  const tileStyle: React.CSSProperties = {
    width: TILE_PX,
    height: TILE_PX,
    borderRadius: t.borderRadiusControl,
    flex: "0 0 auto",
  };
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        loading="lazy"
        style={{ ...tileStyle, objectFit: "cover", border: `1px solid ${t.colors.cardBorder}` }}
      />
    );
  }
  return (
    <div
      role="img"
      aria-label={`${name} (no image)`}
      style={{
        ...tileStyle,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: t.colors.surface,
        border: `1px solid ${t.colors.cardBorder}`,
        color: t.colors.textSecondary,
      }}
    >
      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75}
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        {/* box glyph: a package with no photo */}
        <path d="M21 8l-9-5-9 5v8l9 5 9-5V8zM3 8l9 5 9-5M12 13v8" />
      </svg>
    </div>
  );
}
